// extracted by mini-css-extract-plugin
export default {"container":"Unauthorized_container__5+daS","heading":"Unauthorized_heading__I8FKn","link":"Unauthorized_link__aLMEv","goto":"Unauthorized_goto__WigE4"};